<template>
	<span class="snackbars">
		<span v-for="snackbar in snackbars" :key="snackbar.id">
			<app-snackbar
				app bottom
				:message="snackbar.message"
				:timeout="-1"
				@close="onClose(snackbar.id)"
			/>
		</span>
	</span>
</template>

<script>
export default {
	computed: {
		snackbars() {
			return this.$notifications.getSnackbars()
		},
	},
	methods: {
		onClose(id) {
			this.$notifications.removeSnackbar(id)
		},
	},
}
</script>
